export const lang = {
  companyName: '瞬电科技',
  /* 首页 */
  home: '首页',

  /* 关于我们 */
  aboutUs: '关于我们',
  companyProfile: '企业简介',
  news: '新闻资讯',
  honor: '荣誉',

  /* 产品系列 */
  productGroup: '产品系列',
  highRateCell: '高倍率电芯',
  batteryModule: '电池模组',

  /* 行业解决方案 */
  industrySolutions: '行业解决方案',
  shippingIndustrySolution: '末端寄递行业',
  deliveryIndustrySolution: '即时配送行业',
  policeIndustrySolution: '行政警务行业',
  parkIndustrySolution: '景点园区接驳',
  solutionTxt: '解决方案',
  solutionTxt1: '瞬电为寄递行业末端用电动两、三轮车提供安全便捷的分钟级超级快充系统应用解决方案，应用于城市即时物流末端“最后一公里”场景，叠加“瞬电云”服务，大幅提升场地流转效率和人员接派件效率，节约运营成本，提高站点收益。',
  solutionTxt2: '瞬电为电动两轮外卖车提供分钟级超级快充补能方案，全生命周期数字化安全管控，随充随用，-20℃低温也能快速补能，接单更多,创收更高效！',
  solutionTxt3: '面向城市管理局、环境卫生管理局、消防救援局、工商管理局、邮政局等行政部门和公共事业单位的巡逻应急用车，提供分钟级超级快充、超级安全、快速响应的能源系统解决方案。',
  solutionTxt4: '瞬电针对物流中心、港口、旅游景区、高尔夫球场地等多种复杂工况环境需求，开发出3~6KWh电池组，“充电像加油一样”全天候提供运力服务，有效解决高峰期运力不足、低谷期资产过剩现象。',

  /* 产品解决方案 */
  productSolutions: '产品方案',
  electricalBike: '电动自行车',
  electricalMoto: '电动摩托车',
  electricalThreeWheel: '电动三轮车',
  electricalFourWheel: '场地四轮车',
  agv: 'AGV',

  /* 产品技术优势 */
  techAdvantages: '产品技术优势',
  techIot: '智慧物联技术',
  techSFC: '低压直流超级快充技术',
  techBatteryPack: '分钟级超级快充锂电池组',

  /* 创新技术 */
  technology: '创新技术',
  materialTechnology: '材料技术',
  structuralTechnology: '结构技术',
  cloudPlatform: '安全技术',
  // 瞬电云中心
  shunDianCloud: '瞬电云中心',
  shunDianBigData: '瞬电云大数据',
  BatteryCount: '电池总数',
  ChargingPileCount: '充电机总数',
  StationCount: '站点总数',
  UserCount: '用户总数',
  ChargingTimes: '总充电次数',
  ChargingMinutes: '总充电时长',
  Mileages: '总行驶距离',
  ChargingAmount: '总充电电量',
  DuraionRatio: '总充行时长比',
  danweiZu: '组',
  danweiTai: '台',
  danweiGe: '个',
  danweiMing: '名',
  // 代理商加盟
  agent: '代理商加盟',
  /* 联系我们 */
  contactUs: '联系我们',
  talentRecruitment: '人才招聘',
  channelCooperation: '渠道合作',
  bidAnnouncement: '招标公告',

  privacyPolicyInformationSecurity: '隐私条款和信息安全',
  legalNote: '法律说明',

  homeText: '构建超级快充新场景',
  homeText1: '充电像加油一样',

  newsTitle: '新闻',
  checkMore: '查看更多',

  vision: '愿景',
  visionContent: '以超电动力驱动世界能源变革',
  mission: '使命',
  missionContent: '让超电的创新不止换取用户的能量无限',
  coreValue: '核心价值观',
  coreValueContent: '创新 &nbsp; 卓越 &nbsp; 诚信 &nbsp; 共赢',

  companyProfileInfo: '江苏瞬电网络科技有限公司成立于2018年，是一家以物联网、云计算、大数据为技术基础的新能源运营方案供应商。公司专注于动力电池安全运营和高效充电管理，通过全生命周期主' +
    '动监管实现动力电池长寿命、宽温区、高倍率的安全运营和充电' +
    '管理。公司拥有多项软件著作专利和软硬件综合解决方案，已为' +
    '物流、公安、消防、商用等各领域新能源用户提供了全方位的安' +
    '全、高效服务。',

  previous: '上一页',
  next: '下一页',
  more: '更多',
  operate: '操作',
  check: '查看',
  address: '地址',
  phone: '电话',
  email: '邮箱',
  choseLanguage: '选择语言',
  joinUs: '加盟',
  contactPhone: '联系电话',
  PersonName: '姓名',
  SexMan: '先生',
  SexWoman: '女士',
  Comments: '现从事行业及情况',
  CooperArea: '拟合作区域',
  Province: '省',
  City: '市',
  Area: '区(县)',
  InvestBudget: '投入预算',
  addressInfo: '江苏省无锡市新吴区珠江路50号',
  hasRead: '我已阅读并同意瞬电科技官方网站',
  privatePolicy: '隐私政策',
  submit: '提交',
  privatePolicy1: '为更好的为您服务，请认真填写以上内容。我们会按照相关法律规定，保护您的个人隐私，并尽快于您联系。'
}
